<template>
  <div>
    <v-btn  v-show="activeObject" @click="openSettingObject"  fab dark small color="white" ref="editRef" style="position: absolute;z-index: 9999">
      <v-icon dark>mdi-pencil</v-icon>
    </v-btn>
    <v-btn v-show="activeObject"  @click="copy"fab dark small color="white" ref="copyRef" style="position: absolute;z-index: 9999">
      <v-icon dark>mdi-vector-arrange-below</v-icon>
    </v-btn>
    <v-btn v-show="activeObject"  @click="deleteTable" fab dark small color="white" ref="deleteRef" style="position: absolute;z-index: 9999">
      <v-icon dark>mdi-delete</v-icon>
    </v-btn>
    <canvas id="schema" class="schema" width="500" height="500" style="z-index: 1;"></canvas>
  </div>
</template>

<script>
  import {fabric} from "fabric-with-gestures";
  import 'fabric-customise-controls';


  import Circle from './Cirle'
  import Square from './Square'
  import Grid from './Grid'
  import Fragments from './mixins/fragments'
  import helpers from './mixins/helpers'
  import AutoResizing from './mixins/AutoResizing'
  import TableLoader from './mixins/TableLoader'

  export default {
    props : ['map','tablesExisting'],
    name: "Canvas",
    mixins:[
      Fragments, TableLoader,helpers,AutoResizing
    ],
    mounted() {

      this.initConfig()
        .initCanvas()
        .subscribeCanvasEvents()
        .subscribeBus()
        .drawGrid()

      this.drawGridStatus= true;

      fabric.Object.prototype.hasBorders  = false;
      fabric.Object.prototype.customiseCornerIcons({
        settings: {
          cornerSize: 21,
          cornerShape: 'circle',
          cornerBackgroundColor: '#519888',
          cornerPadding: 10
        },
      }, () => {
        this.canvas.renderAll();
      } );
    },
    watch:{

    },
    data() {
      return {
        globalPosition : {
          left :  150,
          top : 150
        },
        drawGridStatus : false,
        loading: false,
        openSetting : false,
        activeTableId : null,
        activeObject : null,
        config: {
          idCanvas: 'schema',
          coefficient: 1,
          width: 1000,
          height: 700,
        },
        canvas: null,
        tables: [],
      }
    },
    methods: {
      saveMap(payload) {
        this.canvas.setZoom(1);
        bus.$emit('savingModal')
        let tables = [];
        for (let table in this.tables){
          tables.push({
            id: this.tables[table].groupId,
            countPerson: this.tables[table].countPerson,
            tNumber: this.tables[table].groupName,
            zoneId: this.tables[table].zoneId,
          })
        }

        this.removeGrid();
        this.$store.dispatch('restaurantTables/saveTables', {
          tables : tables,
          canvas : JSON.stringify(this.canvas.toJSON(['my','my.id','_controlsVisibility'])),
          restaurantId : payload.restaurantId
        }).then(() => {
          bus.$emit('endSavingModal')
         if(this.drawGridStatus){
           this.drawGrid()
         }

        })

      },
      updatePayloadTable(payload) {
        let table = this.findObjectById(payload.id);
        this.activeTableId = payload.id;

        if (payload.textValue) {
          table.groupName = payload.textValue;
        }
        if (payload.countPerson) {
          table.countPerson = payload.countPerson;
        }
        if (payload.zoneId) {
          table.zoneId = payload.zoneId;
        }
        if (payload.angle) {
          table.angle = payload.angle;
        }
        this.reRenderTable(table)
      },
      subscribeBus() {
        bus.$on('addCircleTable', this.addCircleTable)
          .$on('addSquareTable', this.addSquareTable)
          .$on('deleteTable', this.deleteTable)
          .$on('changeCountPerson', this.updatePayloadTable)
          .$on('saveMap', this.saveMap)
          .$on('changeStatusGrid', this.changeStatusGrid)
          .$on('clickByUnselectableObject', (o) => {
            o.e.preventDefault();
            o.e.stopPropagation()
            bus.$emit('editObject', {
              object : {
                target : o.target
              },
              canvas : this.canvas
            })

            return false;
          })

        return this;
      },

      subscribeCanvasEvents() {
        this.canvas.on("selection:created", this.updateSelectObject)
          .on("selection:updated", this.updateSelectObject)
          .on('object:moved', this.updateOptions)
          .on('object:rotated', this.updateOptions)
          .on('object:scaled', this.updateOptions)
          .on('object:moving', this.autoResizing)
          .on('mouse:dblclick', (o) => {
            this.globalPosition.left = o.pointer.x/this.canvas.getZoom();
            this.globalPosition.top = o.pointer.y/this.canvas.getZoom();
            if(this.canvas.getActiveObject()){
              this.openSettingObject()
            }else{
              this.openSetting = false
              bus.$emit('tableUnselected');
            }
          })

          .on('selection:cleared', (event) => {
            this.activeObject = null;
          });
        return this;
      },

      changeStatusGrid(status){
        this.drawGridStatus = status;
        status ? this.drawGrid() : this.removeGrid();
      },
      removeGrid() {
        document.getElementsByClassName('canvas-container')[0].style.backgroundImage = 'none';
        this.canvas.getObjects().forEach((o) => {
          if (o.customAttribute) {
            this.canvas.remove(o);
          }
        });
      },
      drawGrid() {
        document.getElementsByClassName('canvas-container')[0].style.backgroundImage = 'url(/construct-pattern-transparent.png)';
       // (new Grid(this.canvas, this.config)).drawGrid();
        return this;
      },
      removeTable(id) {
        this.tables = this.tables.filter((table) => table.groupId !== id)
        this.canvas.remove(this.canvas.getActiveObject());
        this.canvas.getObjects().forEach((o) => {
          if (o.my && o.my.id === id) {
            this.canvas.remove(o);
          }
        });
      },
      reRenderTable(table) {
        this.removeTable(table.groupId);
        this.addTable(table);
      },
      updateTableOptions(event){
        let table = this.findObjectById(event.target.my.id);
        if(!table){
          return;
        }
        table.width = table.width * event.target.scaleX;
        table.height = table.height * event.target.scaleY;
        table.radius = table.radius * event.target.scaleY;
        table.angle = event.target.angle
        table.position.left = event.target.left
        table.position.top = event.target.top;
        this.reRenderTable(table)
      },
      updateOptions(event) {
        if(event.target.my){
          return this.updateTableOptions(event)
        }
        this.drawControlObject(event);
        this.showSetting()
      },
      updateSelectTable(o){

        let table = this.findObjectById(o.target.my.id);
        if(!table){
          return;
        }
        bus.$emit('editTable', {
          id: o.target.my.id,
          countPerson: table.countPerson,
          angle: table.angle,
          zoneId: table.zoneId,
          tableNumber: table.groupName
        });
      },
      drawControlObject(o){
        var  buildTable = o.target;
        let minX = 999999999;
        let maxX = 0;
        let minY = 999999999;
        let maxY = 0;

        for(let cur in buildTable.oCoords){
          if(buildTable.oCoords[cur].x > maxX ){
            maxX = buildTable.oCoords[cur].x
          }
          if(buildTable.oCoords[cur].x < minX ){
            minX = buildTable.oCoords[cur].x
          }


          if(buildTable.oCoords[cur].y > maxY ){
            maxY = buildTable.oCoords[cur].y
          }


          if(buildTable.oCoords[cur].y < minY ){
            minY = buildTable.oCoords[cur].y
          }
        }

        minX +=15;
        this.$refs.copyRef.$el.style.top = minY-40+'px';
        this.$refs.copyRef.$el.style.left =minX + (maxX-minX)/2 - 55+'px';

        this.$refs.editRef.$el.style.top = minY-50+'px';
        this.$refs.editRef.$el.style.left =minX + (maxX-minX)/2+'px';
        perPixelTargetFind:true,
        this.$refs.deleteRef.$el.style.top = minY-40+'px';
        this.$refs.deleteRef.$el.style.left =minX + (maxX-minX)/2+55+'px';

      },
      showSetting(){
        if(this.activeObject.my){
          this.updateSelectTable({
            target : this.activeObject
          })
        }else{
          bus.$emit('editObject', {
            object : {
              target : this.activeObject
            },
            canvas : this.canvas
          });
        }
      },
      updateSelectObject(o) {
        this.activeObject = o.target;
        this.showSetting();
        this.drawControlObject(o);
        if(this.openSetting){
          this.openSettingObject()
        }
      },
      deleteTable() {
        if(this.canvas.getActiveObject().my){
          this.removeTable(this.canvas.getActiveObject().my.id)
        }else{
          this.canvas.remove(this.canvas.getActiveObject());
          this.canvas.renderAll();
        }
        this.canvas.renderAll();
        bus.$emit('tableUnselected');
      },
      findObjectById(id) {
        let a;
        this.tables.forEach((table) => {
          if (table.groupId == id) {
            a = table;
            return;
          }
        })
        return a;
      },
      addTable(table) {
        let buildTable = table.build();
        this.tables.push(table);
        this.canvas.add(buildTable);
        this.canvas.setActiveObject(buildTable)
        this.canvas.renderAll();
      },
      addCircleTable() {
        let circle = new Circle();
        circle.position = this.globalPosition;
        this.addTable(circle);
      },
      addSquareTable() {
        let square = new Square();
        square.position = this.globalPosition;
        this.addTable(square);
      },
      initConfig() {
        this.config.width = 1950
        this.config.height = 900
        return this;
      },
      copy(){
        if(this.canvas.getActiveObject().my){
          let table = this.findObjectById(this.canvas.getActiveObject().my.id);
          let param = JSON.parse(JSON.stringify(table));
          param.position.top += 50;
          param.groupId =  Math.ceil(Math.random() * (150 - 1) + 1 + Math.random() * (9999999 - 1) + 1) + '';

          let her = table instanceof Circle ? new Circle() : new Square()
          for (let key in param) {
            her[key] = param[key]; // copies each property to the objCopy object
          }
          this.addTable(her);
        }else{
          this.canvas.getActiveObject().clone((cloned) => {

            cloned.left += 30;
            cloned.top += 30;
            cloned.setControlsVisibility(this.canvas.getActiveObject()['_controlsVisibility'])
            this.canvas.add(cloned);
            this.canvas.setActiveObject(cloned);
          });
        }
        this.showSetting()
      },
      openSettingObject(){
        if(this.activeObject.my){
          bus.$emit('showTableEditor');
        }else{
          bus.$emit('showObjectEditor');
        }
        this.openSetting = true;
      },
      initCanvas() {
        this.canvas = new fabric.Canvas(this.config.idCanvas, {
          width: 2000,//this.config.width,
          height: 1200, //this.config.height,
          containerClassName: this.config.idCanvas,
          selectable:false,
          selection : false,
          controlsAboveOverlay:true,
          centeredScaling:true,
          allowTouchScrolling: true
        });
        //
        if(this.map.length > 30){
          let maxY = 0;
          let maxX = 0;
          this.canvas.loadFromJSON(this.map, () => {
            this.canvas.renderAll();
          }, (o,object) =>{
            if(o.my){
              this.loadTable(o);
            }

            var coords = object.getCoords()
            for (var c in coords) {
              for (var vatt in coords[c]) {
                maxX = maxX >=  coords[c].x ? maxX : coords[c].x;
                maxY = maxY >=  coords[c].y ? maxY : coords[c].y
              }
            }
          })
          this.canvas.set({
            selectable:false,
            selection:false,
            backgroundColor:'#dddddd2e'
          })
          this.canvas.setHeight(maxY > 1200 ? maxY : 1200);
          this.canvas.setWidth(maxX > 2000 ? maxX : 2000);
          this.canvas.renderAll();


        }
        return this;
      }
    }
  }
</script>

<style scoped>

</style>
